import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { InterfaceGeneration } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceGeneration';
export class InterfaceGenerationExtend {
  public static Init(dto: InterfaceGeneration) {
    dto.relationshipType = EnumRelationshipType.InterfaceGeneralization;
  }
}
